import { Market, MarketCode } from '../types/market'

/** Storefront that owns the product, its markets and its checkout. */
export const SHOP_ORIGIN = 'https://elgranretocreativo.shop'
/** Variant sold by every CTA on the page. */
export const VARIANT_ID = '54468175954259'
/** Product handle used to read the localized price from the storefront. */
export const PRODUCT_HANDLE = 'el-gran-reto-creativo'

/**
 * SOURCE OF TRUTH: Shopify Markets + Shopify Payments.
 *
 * These entries hold the LAST KNOWN Shopify values for each market and are
 * shown only until the live localized price for the visitor's country is read
 * from the storefront (see `utils/shopifyPrices.ts`). They are never used to
 * convert currency: when Shopify answers, its amounts replace these 1:1.
 */
export const markets: Record<MarketCode, Market> = {
  US: {
    code: 'US',
    country: 'Estados Unidos',
    flag: '🇺🇸',
    currency: 'USD',
    locale: 'en-US',
    price: '$16.99 USD',
    compareAt: '$33.99 USD',
    savings: '$17.00 USD',
    priceAmount: 16.99,
    compareAtAmount: 33.99,
    usdReference: 16.99,
    roundTo: 0.01,
    live: false,
  },
  MX: {
    code: 'MX',
    country: 'México',
    flag: '🇲🇽',
    currency: 'MXN',
    locale: 'es-MX',
    price: '$349.00 MXN',
    compareAt: '$699.00 MXN',
    savings: '$350.00 MXN',
    priceAmount: 349,
    compareAtAmount: 699,
    usdReference: 16.99,
    roundTo: 10,
    live: false,
  },
  CL: {
    code: 'CL',
    country: 'Chile',
    flag: '🇨🇱',
    currency: 'CLP',
    locale: 'es-CL',
    price: '$15.990 CLP',
    compareAt: '$31.990 CLP',
    savings: '$16.000 CLP',
    priceAmount: 15990,
    compareAtAmount: 31990,
    usdReference: 16.99,
    roundTo: 500,
    live: false,
  },
  CO: {
    code: 'CO',
    country: 'Colombia',
    flag: '🇨🇴',
    currency: 'COP',
    locale: 'es-CO',
    price: '$69.900 COP',
    compareAt: '$139.900 COP',
    savings: '$70.000 COP',
    priceAmount: 69900,
    compareAtAmount: 139900,
    usdReference: 16.99,
    roundTo: 1000,
    live: false,
  },
  ES: {
    code: 'ES',
    country: 'España',
    flag: '🇪🇸',
    currency: 'EUR',
    locale: 'es-ES',
    price: '15,99 €',
    compareAt: '31,99 €',
    savings: '16,00 €',
    priceAmount: 15.99,
    compareAtAmount: 31.99,
    usdReference: 16.99,
    roundTo: 0.01,
    live: false,
  },
  PE: {
    code: 'PE',
    country: 'Perú',
    flag: '🇵🇪',
    currency: 'PEN',
    locale: 'es-PE',
    price: 'S/ 62.00',
    compareAt: 'S/ 125.00',
    savings: 'S/ 63.00',
    priceAmount: 62,
    compareAtAmount: 125,
    usdReference: 16.99,
    roundTo: 0.5,
    live: false,
  },
}

export const marketList: Market[] = [
  markets.CL,
  markets.CO,
  markets.ES,
  markets.US,
  markets.MX,
  markets.PE,
]

/**
 * Shopify cart permalink used by EVERY CTA on the page.
 * Adds exactly 1 unit and opens the CART page (never checkout).
 * `country` pins the same Shopify market the visitor saw on the landing page,
 * so cart and checkout show the exact same localized amount.
 */
export function cartUrl(code: MarketCode): string {
  return `${SHOP_ORIGIN}/cart/${VARIANT_ID}:1?storefront=true&country=${code}`
}
